module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_16_9_w_768.c5366ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_16_9_w_768.jpg
// module id = eL4H
// module chunks = 0